import Vue from 'vue';
import FocusVisiblePlugin from '@/plugins/focus-visible-polyfill';

Vue.use(FocusVisiblePlugin);
